import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { ArrowBackRounded, ArrowForwardRounded, ShieldOutlined } from '@mui/icons-material'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import CoverReasonIcon from './coverReasonIcon'
import { useVision } from './visionContext'
import { COVER_REASON_SUBTITLE, COVER_REASON_TEXT, PERMISSION_HELP_TEXT } from './visionState'

// Story 213 C11.8 — the one cover template: round icon in the colour of the reason, title, subtitle, the permission
// help (RN23.3) and Back only when Sun says the leave would be accepted now (`canLeave`, DB-4). Used by the
// full-screen overlay (mode ALL); a covered boundary in SENSITIVE_ONLY is the blurred placeholder instead (C15.6).
const VisionCoverNotice = ({ state, cameraFailure, onBack }) => {
  const { t_ } = useSmartTranslation()
  const { canGoToCameraControl, goToCameraControl } = useVision()
  // A 423 before Sun said why (no reason yet) reads as STARTING, like its icon (coverReasonIcon).
  const title = COVER_REASON_TEXT[state.coverReason] || COVER_REASON_TEXT.STARTING
  const subtitle = COVER_REASON_SUBTITLE[state.coverReason] || ''
  const noCamera = state.coverReason === 'NO_CAMERA'

  return (
    <>
      <CoverReasonIcon reason={state.coverReason} size={64} />
      {title && (
        <Typography component='p' sx={{ fontSize: 22, fontWeight: 700, color: '#FFFFFF', textAlign: 'center' }}>
          {t_(title)}
        </Typography>
      )}
      {subtitle && (
        <Typography component='p' sx={{ fontSize: 14, color: '#BDBDBD', textAlign: 'center' }}>{t_(subtitle)}</Typography>
      )}
      {noCamera && cameraFailure === 'PERMISSION_DENIED' && (
        <Typography component='p' sx={{ fontSize: 14, color: '#BDBDBD', textAlign: 'center' }}>{t_(PERMISSION_HELP_TEXT)}</Typography>
      )}
      {noCamera && state.canLeave && (
        <Button
          variant='outlined'
          startIcon={<ArrowBackRounded />}
          onClick={onBack}
          sx={{ borderRadius: 999, borderColor: '#7FE1A7', color: '#7FE1A7', minHeight: 40, px: 2.25 }}
        >
          {t_('Back')}
        </Button>
      )}
      {/* C14.3 (PO, 2026-10-22; Capa.dc.html): the way out for ADMIN and SUPERADMIN, apart from the action of the reason and
          in grey, so it does not compete with it; only in the full-screen overlay (reopening 3, DK-2). */}
      {canGoToCameraControl && (
        <Box
          data-testid='admin-exit'
          sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, mt: 0.75, pt: 1.75, borderTop: '1px solid #3A3A3A', width: 'min(320px, 80%)' }}
        >
          <Box component='span' sx={{ display: 'flex', alignItems: 'center', gap: 0.75, fontSize: 12, fontWeight: 600, letterSpacing: 0.4, color: '#A8A8A8' }}>
            <ShieldOutlined sx={{ fontSize: 14 }} />
            {t_('Admins only')}
          </Box>
          <Button
            variant='outlined'
            endIcon={<ArrowForwardRounded />}
            onClick={goToCameraControl}
            sx={{ borderRadius: 999, borderColor: '#CFCFCF', color: '#FFFFFF', minHeight: 40, px: 2.25, textTransform: 'none', fontWeight: 600 }}
          >
            {t_('Go to camera control')}
          </Button>
        </Box>
      )}
    </>
  )
}

export default VisionCoverNotice
